import { render, staticRenderFns } from "./CommunityReminders.vue?vue&type=template&id=11f7fab3&scoped=true&"
import script from "./CommunityReminders.vue?vue&type=script&lang=js&"
export * from "./CommunityReminders.vue?vue&type=script&lang=js&"
import style0 from "./CommunityReminders.vue?vue&type=style&index=0&id=11f7fab3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f7fab3",
  null
  
)

export default component.exports